import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import swal from "sweetalert";
import LogoutFunction from "../../../services/LogoutFunction";

export const diplomaPayment = createAsyncThunk(
  "payment/getAlldiplomas",
  async () => {
    const tokenData = await JSON.parse(localStorage.getItem("userData")).token;
    const request = await fetch(
      `${process.env.REACT_APP_VERSEL_API}/api/user/payment/diplomes`,
      {
        method: "GET",
        headers: {
          Authorization: `Bearer ${tokenData}`,
        },
      }
    )
      .then((response) => response.json())
      .then((result) => {
        return result;
      })
      .catch((error) => {
        return error;
      });

    return request;
  }
);

function formatError(errorResponse) {
  swal("Oops", `${errorResponse}`, "error");
}

const getDiplomaPaymentsSlicer = createSlice({
  name: "payments/diplomas",
  initialState: {
    loading: false,
    data: null,
    error: null,
  },
  extraReducers: (builder) => {
    builder.addCase(diplomaPayment.pending, (state) => {
      state.loading = true;
    });
    builder.addCase(diplomaPayment.fulfilled, (state, action) => {
      state.loading = false;
      if (action.payload.message === "jwt expired") {
        state.error = action.payload.message;
        formatError(state.error);
        LogoutFunction();
      } else if (action.payload.message ===  "fetched successfully") {
        state.data = action.payload;
      } else {
        state.error = action.payload.message;
      }
    });
    builder.addCase(diplomaPayment.rejected, (state, action) => {
      state.loading = false;
      state.error = action.payload.message;
    });
  },
});

export default getDiplomaPaymentsSlicer.reducer;
